import { Navigate, useLocation, useParams } from 'react-router';

import { RoutePath } from 'enums/routePath';

const TradeInLegacyRedirect = () => {
  const { hash, search } = useLocation();
  const { '*': remainingPath } = useParams();
  const pathname = remainingPath ? `${RoutePath.TRADE_IN_ITEMS}/${remainingPath}` : RoutePath.TRADE_IN_ITEMS;

  return <Navigate replace to={{ hash, pathname, search }} />;
};

export default TradeInLegacyRedirect;
